"use client";

import React, { useState, useEffect } from "react";
import { fetchUserAttributes } from "aws-amplify/auth";
import {
  addsavedcitybyuser,
  checkSavedcitybyuserStatus,
} from "../../../modules/Graphql/savedcitybyusergraphql.js";
import { createsubscription } from "../../../modules/Graphql/neighborhoodgraphql.js";
import ShareModal from "./ShareModal";
import SaveCityButton from "./SaveCityButton";
import FollowCityPopup from "./FollowCityPopup";
import ShareButton from "../../Neighborhood/[id]/ShareButton";
import { customStyles } from "../../Neighborhood/[id]/modalStyles.js";
import SubscribeModal from "../../Neighborhood/[id]/SubscribeModal.js";

export default function CityActionButtons({ cityId, cityDetails }) {
  const [loggedin, setLoggedin] = useState(false);
  const [userId, setUserId] = useState("");
  const [isMobile, setIsMobile] = useState(false);
  const [save, setSave] = useState(false);

  const [subscribemodal, setSubscribemodal] = useState(false);
  const [subscribeemail, setSubscribeemail] = useState("");
  const [subscribeemailstatus, setSubscribeemailstatus] = useState(false);
  const [subscribe_err_msg, setSubscribe_err_msg] = useState("");
  const [subscribe_success_msg, setSubscribe_success_msg] = useState("");
  const [clickedItem, setClickedItem] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);

  useEffect(() => {
    const checkUserStatus = async () => {
      try {
        const attributes = await fetchUserAttributes();
        const userEmail = attributes.email;

        setLoggedin(true);

        const storedUserId = localStorage.getItem("userId");
        if (storedUserId) {
          setUserId(storedUserId);
        }
      } catch (error) {
        setLoggedin(false);
        setUserId("");
      }
    };

    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 767);
    };

    checkUserStatus();
    checkMobile();

    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  useEffect(() => {
    const checkSavedStatus = async () => {
      if (!userId || !cityId) return;

      try {
        const adddata = {
          userId: userId,
          name: cityDetails?.[0]?.postalcity_name || cityId,
        };

        const result = await checkSavedcitybyuserStatus(adddata);

        let savedStatus = 0;
        if (
          result.data &&
          result.data.checkSavedcitybyuserStatus &&
          result.data.checkSavedcitybyuserStatus.length > 0
        ) {
          savedStatus = result.data.checkSavedcitybyuserStatus[0].savedStatus;
        }

        setSave(savedStatus === 1);
      } catch (error) {
        console.error("Error checking saved status:", error);
      }
    };

    checkSavedStatus();
  }, [userId, cityId, cityDetails]);

  const handleSaveCity = async () => {
    if (!loggedin) {
      localStorage.setItem("saveN", "saveCity");
      localStorage.setItem(
        "savecityid",
        cityDetails?.[0]?.postalcity_name || cityId,
      );
      localStorage.setItem("previous_url", window.location.href);

      const signUpBtn = document.getElementById("sign_up_btn");
      if (signUpBtn) {
        signUpBtn.click();
      }
      return;
    }

    const newSaveState = !save;
    setSave(newSaveState);

    try {
      const adddata = {
        userId: userId,
        name: cityDetails?.[0]?.postalcity_name || cityId,
        city: cityDetails?.[0]?.postalcity_name || "",
        state: cityDetails?.[0]?.state_name || "",
        savedDate: new Date(),
        updatedDate: new Date(),
        savedStatus: 1,
      };

      const result = await addsavedcitybyuser(adddata);

      if (
        result.data.createsavedcitybyuser.message ===
        "City removed successfully!"
      ) {
        setSave(false);
      } else {
        setSave(true);
      }
    } catch (error) {
      console.error("Error saving city:", error);
      // Revert state on error
      setSave(!newSaveState);
    }
  };

  const handleSubscribeClick = (item) => {
    setSubscribeemail("");
    setSubscribeemailstatus(false);
    setSubscribe_err_msg("");
    setClickedItem(item);
    setSubscribe_success_msg("");
    setSubscribemodal(true);
  };

  const closeSubscribeModal = () => {
    setSubscribemodal(false);
    setSubscribeemail("");
    setSubscribeemailstatus(false);
    setSubscribe_err_msg("");
    setSubscribe_success_msg("");
  };

  const handleEmailChange = (e) => {
    setSubscribeemail(e.target.value);
    setSubscribeemailstatus(false);
    setSubscribe_err_msg("");
    setSubscribe_success_msg("");
  };

  const handleSubscribeSubmit = async (e) => {
    e.preventDefault();

    const emailRegex = new RegExp(
      "^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]$",
    );

    if (subscribeemail === "") {
      setSubscribeemailstatus(true);
      setSubscribe_err_msg("Please enter your email");
      return;
    }

    if (!emailRegex.test(subscribeemail)) {
      setSubscribeemailstatus(true);
      setSubscribe_err_msg("Please enter valid email!");
      return;
    }

    setSubscribeemailstatus(false);
    setSubscribe_err_msg("");
    setIsLoading(true);

    try {
      const currentDate = new Date();
      const formattedDate = currentDate.toISOString().slice(0, 10);
      const slug =
        cityDetails?.[0]?.postalcity_name ||
        window.location.pathname.split("/").pop();

      const addsubscriptionData = {
        email: subscribeemail,
        subscribe_for: clickedItem,
        date: formattedDate,
        neighborhoodid: cityId,
        neighborhoodfullname: slug,
      };

      const result = await createsubscription(addsubscriptionData);

      if (!result.data.createsubscription.success) {
        setSubscribeemailstatus(true);
        setSubscribe_err_msg(result.data.createsubscription.message);
        setSubscribe_success_msg("");
        setIsLoading(false);
      } else {
        setSubscribe_success_msg("Subscription added successfully");
        setIsLoading(false);
        setTimeout(() => {
          closeSubscribeModal();
        }, 1000);
      }
    } catch (error) {
      console.error("Error creating subscription:", error);
      setSubscribeemailstatus(true);
      setSubscribe_err_msg("An error occurred. Please try again.");
      setIsLoading(false);
    }
  };

  const handleShareClick = () => {
    setIsShareModalOpen(true);
  };

  const handleCloseShareModal = () => {
    setIsShareModalOpen(false);
  };

  return (
    <>
      {/* Save City Button (for logged-in users) */}
      <SaveCityButton
        loggedin={loggedin}
        save={save}
        isMobile={isMobile}
        onSaveCity={handleSaveCity}
      />

      {/* Follow City Button (for non-logged-in users) */}
      <FollowCityPopup
        loggedIn={loggedin}
        isMobile={isMobile}
        onSubscribeClick={handleSubscribeClick}
      />

      {/* Share this page Button */}
      <div className="share-button-container">
        <ShareButton
          isMobile={isMobile}
          handleShareButtonClick={handleShareClick}
        />

        {isShareModalOpen && (
          <ShareModal
            isShareModalOpen={isShareModalOpen}
            handleCloseShareModal={handleCloseShareModal}
          />
        )}
      </div>

      {/* Subscribe Modal */}
      {subscribemodal && (
        <SubscribeModal
          subscribemodal={subscribemodal}
          closesubscribemodal={closeSubscribeModal}
          customStyles={customStyles}
          SubscribtionModalSubmit={handleSubscribeSubmit}
          subscribeemail={subscribeemail}
          handlesubscribeemailChange={handleEmailChange}
          subscribeemailstatus={subscribeemailstatus}
          subscribe_err_msg={subscribe_err_msg}
          subscribe_success_msg={subscribe_success_msg}
          isLoading={isLoading}
          page="city"
        />
      )}
    </>
  );
}
